import { render } from "./BirthdayReport.vue?vue&type=template&id=8f64bf86&scoped=true"
import script from "./BirthdayReport.vue?vue&type=script&lang=js"
export * from "./BirthdayReport.vue?vue&type=script&lang=js"

import "./BirthdayReport.vue?vue&type=style&index=0&id=8f64bf86&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f64bf86"]])

export default __exports__